/**
 * Shared ATC / main-thread helpers.
 * Loaded after window.theme is defined (deferred; safe by first interaction).
 */
(function initThemeAtc(theme) {
  if (!theme || theme.yieldToMain) return;

  /**
   * Yield so the browser can paint before more JS (INP).
   * Prefer scheduler.yield; fall back to a double rAF.
   */
  theme.yieldToMain = function yieldToMain() {
    if (window.scheduler && typeof window.scheduler.yield === 'function') {
      return window.scheduler.yield();
    }
    return new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });
  };

  theme.atc = {
    /** Section IDs to request with cart/add for icon + drawer HTML. */
    sectionIds(cartDrawer) {
      let sections = 'cart-icon-bubble';
      if (!cartDrawer) return sections;
      const sectionEl = cartDrawer.closest('.shopify-section');
      if (sectionEl && sectionEl.id) {
        sections += `,${sectionEl.id.replace('shopify-section-', '')}`;
      }
      return sections;
    },

    /**
     * Paint has already shown loading on submitter.
     * Yield, then open the cart drawer (drawer defers trapFocus itself).
     */
    async openDrawerAfterPaint(cartDrawer, submitter, quickAddDrawer) {
      if (!cartDrawer || quickAddDrawer || theme.settings.afterAtc !== 'drawer') return;
      await theme.yieldToMain();
      cartDrawer.open(submitter);
    },

    updateCartIcon(response) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && response && response.sections && response.sections['cart-icon-bubble']) {
        bubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    },

    vibrate() {
      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }
    },

    /** Restore submitter after settle (success chrome optional). */
    finishSubmitter(submitter, { success = true } = {}) {
      if (!submitter) return;
      if (success) submitter.classList.add('is-success');
      submitter.removeAttribute('aria-disabled');
      if (submitter.disabled) submitter.disabled = false;
      setTimeout(() => {
        submitter.classList.remove('is-loading');
        submitter.classList.remove('is-success');
      }, 1400);
    }
  };
})(window.theme);
